import React from 'react';
import './Contact.css';
import kImage from './Assets/k.webp';

export default function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-image">
          <img src={kImage} alt="K-Alterations" />
        </div>
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <div className="contact-divider"></div>
          <p className="contact-intro">
            Ready to get the right fit? Contact us today to ask about our services or walk in to get fitted.
          </p>
          <div className="contact-details">
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h4>Location</h4>
                <p>Located in the Janesville Mall <br />2500 Milton Ave Suite #132, Janesville, WI 53545</p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone-alt"></i>
              <div>
                <h4>Phone</h4>
                <p>(608)-741-4122</p>
              </div>
            </div>

            <div className="contact-item">
              <i className="fas fa-clock"></i>
              <div>
                <h4>Hours</h4>
                <p>Mon - Sat: 10am - 7pm<br />Sun: closed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
